<template>
<transition name="fade">
  <div class="to-top-container" @click="scrollToTop" v-if="is_show">
    <img :src="cc.bg" alt="">
  </div>
</transition>
</template>

<script>
import { ComponentCommonMixin } from '../mixin'
import { utils } from '_lib/utils'
let timer = null
export default {
  mixins: [ ComponentCommonMixin ],
  data () {
    return {
      is_show: false
    }
  },
  mounted () {
    const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    if (this.gc.bg_fixed) {
      document.querySelector('#outer-content').addEventListener('scroll', e => {
        this.checkScrollTop(e.target.scrollTop, height)
      })
    } else {
      window.addEventListener('scroll', e => {
        this.checkScrollTop(document.documentElement.scrollTop || document.body.scrollTop, height)
      })
    }
  },
  methods: {
    checkScrollTop (scrollTop, height) {
      if (scrollTop > (height / 2)) {
        if (!this.is_show) {
          this.is_show = true
        }
      } else {
        if (this.is_show) {
          this.is_show = false
        }
      }
    },
    scrollToTop () {
      clearTimeout(timer)
      utils.easeOutScrollTo(0, this.gc.bg_fixed ? document.querySelector('#outer-content') : null)
    },
    scrollTo (pos){
      let gap = document.documentElement.scrollTop || document.body.scrollTop
      if (this.gc.bg_fixed) {
        gap = document.querySelector('#outer-content').scrollTop
      }
      const delta = pos - gap
      let speed = delta / 6
      console.log(speed, this.speed);
      if (speed === this.speed) {
        return
      }
      this.speed = speed
      speed = Math.floor(speed)
      if (delta !== 0) {
        if (this.gc.bg_fixed) {
          document.querySelector('#outer-content').scrollTo(0, gap + speed)
        } else {
          window.scrollTo(0, gap + speed)
        }
        timer = setTimeout(() => {
          this.scrollTo(pos)
        }, 17)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.fade-enter-active, .fade-leave-active {
  transition: all 0.35s cubic-bezier(0.24, 0.01, 0.24, 1);
}
.fade-enter, .fade-leave-to {
  transition: all 0.35s cubic-bezier(0.24, 0.01, 0.24, 1);
  opacity: 0;
}
.fade-enter-to, .fade-leave {
  opacity: 1;
}
.to-top-container {
  position: fixed;
  right: 20px;
  bottom: 15%;
  width: 42px;
  height: 42px;
  z-index: 1000;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>